import { useEffect } from 'react';
import { Tenant } from 'shared/types';

import ConsentStorage from '../cookiesManagement/ConsentStorage';
import { ConsentPurposes } from '../cookiesManagement/types';
import Analytics from './analytics';
import { AnalyticsConfig } from './types';

export function useAnalytics(tenant: Tenant | null) {
    useEffect(function conditionallyInitAnalytics() {
        const consentStorage = ConsentStorage.getInstance();
        const measurementConsent = consentStorage.getConsent(ConsentPurposes.measurement);

        if (tenant && tenant.clarityEnabled && measurementConsent) {
            Analytics.init(createAnalyticsConfig(tenant));
        }
    }, [ tenant ]);
}

function createAnalyticsConfig(tenant: Tenant): AnalyticsConfig {
    // Every enabled feature flag rides as a `flag_<Name>` property so events
    // are sliceable by enablement in GA/Clarity/PostHog.
    const flagProps = Object.fromEntries(
        Object.entries(tenant.featuresEnabled ?? {}).map(([ k, v ]) => [ `flag_${ k }`, Boolean(v) ])
    );

    return {
        tenant: tenant.tenantName,
        userId: tenant.sessionInfo.userId,
        clarityEnabled: tenant.clarityEnabled,
        properties: flagProps
    };
}
